import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './styles/App.css';

import Header from './components/common/Header';
import Footer from './components/common/Footer/Footer';
import ScrollToTop from './components/common/ScrollToTop';
import LandingPage from './components/LandingPage/LandingPage';

const BMICalculator = lazy(() => import('./components/BMICalculator/BMICalculator'));
const IdealWeightCalculator = lazy(() => import('./components/Calculators/IdealWeightCalculator'));
const CalorieIntakeCalculator = lazy(() => import('./components/Calculators/CalorieIntakeCalculator'));
const CaloriesBurnedCalculator = lazy(() => import('./components/Calculators/CaloriesBurnedCalculator'));
const ComingSoon = lazy(() => import('./components/common/ComingSoon/ComingSoon'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const Contact = lazy(() => import('./pages/Contact'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));

const LoadingFallback = () => (
  <div className="loading-spinner-inline">
    <div className="spinner-small"></div>
  </div>
);

const LazyRoute = ({ component: Component, ...props }) => (
  <Suspense fallback={<LoadingFallback />}>
    <Component {...props} />
  </Suspense>
);

function AppContent() {
  const location = useLocation();
  const isCalculator =
    location.pathname === '/bmi-calculator' ||
    location.pathname === '/ideal-weight-calculator' ||
    location.pathname === '/calorie-intake-calculator' ||
    location.pathname === '/calories-burned-calculator';

  return (
    <div className={`app ${isCalculator ? 'app-calculator' : ''}`}>
      <ScrollToTop />
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/bmi-calculator" element={<LazyRoute component={BMICalculator} />} />
          <Route path="/ideal-weight-calculator" element={<LazyRoute component={IdealWeightCalculator} />} />
          <Route path="/calorie-intake-calculator" element={<LazyRoute component={CalorieIntakeCalculator} />} />
          <Route path="/calories-burned-calculator" element={<LazyRoute component={CaloriesBurnedCalculator} />} />
          <Route path="/about" element={<LazyRoute component={AboutUs} />} />
          <Route path="/contact" element={<LazyRoute component={Contact} />} />
          <Route path="/privacy" element={<LazyRoute component={PrivacyPolicy} />} />
          <Route path="/terms" element={<LazyRoute component={TermsOfService} />} />
          <Route path="/coming-soon" element={<LazyRoute component={ComingSoon} />} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
